// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__1e-et","content":"LayoutSettings_content__12fDT"};